import { palette } from '../../theme';

export const pbiFilterSystemGroupStyles = {
  toggleButtonGroup: {
    boxSizing: 'border-box' as const,
    width: '147px',
    height: '36px',
    border: `1px solid ${palette.text.secondary}`,
    borderRadius: '4px',
    padding: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '15px',
    '& .MuiToggleButtonGroup-grouped': {
      border: 'none',
      borderRadius: '2px !important',
      width: '100%',
      height: '100%',
      padding: 0,
      '&:not(:first-of-type)': {
        borderRadius: '2px !important',
      },
      '&:first-of-type': {
        borderRadius: '2px !important',
      },
    },
    '& .MuiToggleButton-root': {
      '& svg': {
        stroke: palette.grey[300],
        fill: palette.grey[300],
      },
      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        '& svg': {
          stroke: 'white',
          fill: 'white',
        },
        '&:hover': {
          backgroundColor: palette.primary.main,
        },
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
};
